/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.0
 */


import { ValueOf } from '../../../types/globalTypes';
import { IFilterSort, IOnFilterChangeParams, ISortEnum, SortEnum } from '../components/Filters/Filter';

/**
 * @description Define filter payload.
 * @interface ISetFilterPayload
 * @property {string} field Filter field name.
 * @property {IOnFilterChangeParams} value Filter value
 */
export interface ISetFilterPayload {
    field: string;
    value: IOnFilterChangeParams;
}

export const onFilterChange = (field: string, setFilter: (arg: any) => void) => {
    return (values: IOnFilterChangeParams) => {
        setFilter({
            field,
            value: values,
        });
    };
};

/**
 * @description Define historyOrder payload.
 * @interface ISetOrderPayload
 * @property {string} field Filter field name.
 * @property {SortEnum} historyOrder Sort value
 */
export interface ISetOrderPayload {
    field: string;
    order: ValueOf<ISortEnum>;
}

export const setOrder = (sort: IFilterSort, field: string): ValueOf<ISortEnum> => {
    if (sort && (field !== sort.property || sort.direction === SortEnum.default)) {
        return SortEnum.ascending;
    } else if (sort && sort.direction === SortEnum.ascending) {
        return SortEnum.descending;
    } else {
        return SortEnum.default;
    }
};
